import { getField, updateField } from 'vuex-map-fields';

export default {
    namespaced: true,

    state: {
        property: null,
        noteTypes: null,
        notes: null,
        fixfloUrl: null,
    },

    getters: {
        getField,

        // Notes
        parsedNoteTypes: (state) => {
            let result = [];

            // turn object into array
            if(state.noteTypes && state.noteTypes.Rows && state.noteTypes.Rows.length) {
                result = state.noteTypes.Rows.map((row) => row.strLinkType);
            }

            return result;
        },
        hasNotes: (state) => {
            return (state.notes && state.notes.RowCount);
        },
    },

    actions: {
        reset({ commit }) {
            commit('setProperty', null);
        },
        getRow({ commit }, propertyPK) {
            return axios.get(`/api/contacts/leaseholder/properties/${propertyPK}`)
            .then((response) => {
                commit('setProperty', response.data.data);
            })
            .catch(() => {
                commit('setProperty', null);
            });
        },
        getNoteTypes({ commit, state }) {
            commit('setNoteTypes', null);

            return axios.get(`/api/contacts/leaseholder/properties/${state.property.PropertyPK}/notes/types`)
            .then((response) => {
                commit('setNoteTypes', response.data.data);
            })
            .catch(() => {
                commit('setNoteTypes', []);
            });
        },
        getNotes({ commit, state }, params) {
            commit('setNotes', null);

            return axios.get(`/api/contacts/leaseholder/properties/${state.property.PropertyPK}/notes`, {
                params: params,
            })
            .then((response) => {
                commit('setNotes', response.data.data);
            })
            .catch(() => {
                commit('setNotes', []);
            });
        },
        getFixfloUrl({ commit }, propertyPK) {
            return axios.get(`/api/contacts/leaseholder/properties/${propertyPK}/estate/fixflo-url`)
            .then((response) => {
                commit('setFixfloUrl', response.data.data.url);
            })
            .catch(() => {
                commit('setFixfloUrl', null);
            });
        },
    },

    mutations: {
        updateField,
        setProperty(state, property) {
            state.property = property;
        },
        setNoteTypes(state, noteTypes) {
            state.noteTypes = noteTypes;
        },
        setNotes(state, notes) {
            state.notes = notes;
        },
        setFixfloUrl(state, url) {
            state.fixfloUrl = url;
        },
    },
};
